export const residencyMapFilters = [
  {
    key: "clinical",
    title: "Szpital kliniczny",
    shortTitle: "Kliniczny",
  },
  {
    key: "non-clinical",
    title: "Szpital niekliniczny",
    shortTitle: "Niekliniczny",
  },
  {
    key: "military",
    title: "Szpital wojskowy",
    shortTitle: "Wojskowy",
  },
  {
    key: "health-center",
    title: "Przychodnia",
    shortTitle: "Przychodnia",
  },
];

export const internshipMapFilters = [
  {
    key: "clinical",
    title: "Szpital kliniczny",
    shortTitle: "Kliniczny",
  },
  {
    key: "non-clinical",
    title: "Szpital niekliniczny",
    shortTitle: "Niekliniczny",
  },
  {
    key: "military",
    title: "Szpital wojskowy",
    shortTitle: "Wojskowy",
  },
];
